import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController, Loading } from 'ionic-angular';
import { User } from '../../providers';
import { ResultadosPage } from '../resultados/resultados';
import { FirstPage } from '../first/first';

/**
 * Generated class for the TestPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-test',
  templateUrl: 'test.html',
})
export class TestPage {

  userData = {};
  private loginErrorString: string;

  question;
  id;
  facultad;
  no: number;
  ans;
  userTo: {};
  satatus = 0;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams, public user: User, 
    public alertCtrl: AlertController, public toastCtrl: ToastController, public loadingController: LoadingController) {
    this.ans = 1;
    console.log("answered: "+this.navParams.get("answered"));
    console.log("token: "+this.navParams.get("token"));
    console.log("user: "+this.navParams.get("user"));

    this.userData = "{\"where\":{\"no\":\""+(this.navParams.get("answered")+1)+"\"}}";
    var url = "Questions?filter="+this.userData;

    this.user.getCurrentAnswer(url, {}).subscribe((resp) => {
      console.log("Ok: status: "+resp);
      console.log("Ok: data: "+ JSON.stringify(resp));

      console.log("Qid: "+ JSON.stringify(resp[0].question));
      console.log("facultad: "+ JSON.stringify(resp[0].facultad));

      this.question = JSON.stringify(resp[0].question).replace("\"","").replace("\"","");
      this.id = JSON.stringify(resp[0].id).replace("\"","").replace("\"","");
      this.facultad = JSON.stringify(resp[0].facultad).replace("\"","").replace("\"","");
      this.no = this.navParams.get("answered")+1;

    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); 

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      toast.present();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TestPage');
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

  doAnswer() {
    
    this.loading = this.loadingController.create({content : "Guardando, porfavor espera un momento..."});
    this.loading.present();
    

    console.log("do Answer.");
    var url = "accounts/addAnswer?access_token=".concat(""+this.navParams.get("token")).concat("&data=").concat("{\"id\":\""+this.navParams.get("user")+"\",\"answer\":{\"answer\":\""+ this.ans+"\",\"question\":\""+this.id+"\",\"facultad\":\""+this.facultad+"\"}}");
    console.log("url: "+url);
    this.user.addAnswer(url, {}).subscribe((resp) => {

      console.log("values result: "+resp);
      console.log("result: "+ resp);

      this.addQuestionCount();

    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); 

      this.loading.dismissAll();

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      toast.present();
    });
  }

  changeStatus(answer: String) {
    this.ans = answer;
  }

  addQuestionCount() {
    console.log("do Update Question number.");

    this.userData = {"answered": this.no };

    var url = "accounts/update?where={\"id\":\""+this.navParams.get("user")+"\"}&access_token="+this.navParams.get("token");

    this.user.addAnswer(url, { "answered": this.no }).subscribe((resp) => {

      console.log("values result: "+ JSON.stringify(resp));
      if(this.no == 88) {
        console.log("final question");
        this.doFinishTest();
      } else {
        this.changeQuestion();
      }

    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); 

      this.loading.dismissAll();
      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      
      toast.present();
    });
  }

  changeQuestion() {

    console.log("do changeQuestion");
    var actualno : number = this.no + 1;
    console.log("actualno: "+ actualno);

    this.userData = "{\"where\":{\"no\":\""+actualno+"\"}}";
    var url = "Questions?filter="+this.userData;

    this.user.getCurrentAnswer(url, {}).subscribe((resp) => {
      console.log("Ok: status: "+resp);
      console.log("Ok: data: "+ JSON.stringify(resp));

      this.question = JSON.stringify(resp[0].question).replace("\"","").replace("\"","");
      this.id = JSON.stringify(resp[0].id).replace("\"","").replace("\"","");
      this.facultad = JSON.stringify(resp[0].facultad).replace("\"","").replace("\"","");
      this.no = actualno;

      this.loading.dismissAll();

    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); 

      this.loading.dismissAll();

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      
      toast.present();
    });
    
  }

  doFinishTest(){
    this.userData = { "teststatus": 2 };

    var url = "accounts/update?where={\"_id\":\"".concat(this.navParams.get("user")).concat("\"}&access_token=").concat(this.navParams.get("token"));
    this.user.addAnswer(url, { "teststatus": 2 }).subscribe((resp) => {

      this.satatus = 2;

      this.loading.dismissAll();

      this.navCtrl.push(ResultadosPage, 
        { 
          user: this.navParams.get("user"),
          answered: this.navParams.get("answered"),
          token: this.navParams.get("token"),
          from_test: true
        });

    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); 

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      toast.present();
    });
  }

  ionViewDidLeave() {
    console.log("ionViewDidLeave");
    let status: number;
    if(this.no == 88) {
      status = 2;
    } else {
      status = 1;
      this.navCtrl.setRoot(FirstPage, 
        { 
          user : {
            userId: this.navParams.get("user"),
            id: this.navParams.get("token") ,
            user: {
              firstname: '',
              teststatus: status
            }
          }
        });
      this.navCtrl.popToRoot();
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/test/test.ts